import { combineReducers } from "redux";

import controls from "modules/controls";
import map from "modules/map";
import library from "modules/library";
import search from "modules/search";
import magazines from "modules/magazine";
import article from "modules/article";
import rubric from "modules/rubric";
import favorite from "modules/favorite";
import banner from "modules/banner";
import banner_top from "modules/banner_top";
import order from "modules/order";
import specials from "modules/specials";
import events from "modules/events";
import articles from "modules/articles";

export default combineReducers({
  controls: controls.reducer,
  map: map.reducer,
  library: library.reducer,
  search: search.reducer,
  magazine: magazines.reducer,
  article: article.reducer,
  rubric: rubric.reducer,
  favorite: favorite.reducer,
  banner: banner.reducer,
  banner_top: banner_top.reducer,
  order: order.reducer,
  specials: specials.reducer,
  events: events.reducer,
  articles: articles.reducer
});



// WEBPACK FOOTER //
// ./src/rootReducer.js